import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Localization = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path
                d="M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M21 5C21 4.44772 20.5523 4 20 4C19.4477 4 19 4.44772 19 5V7.37223C12.8018 7.8563 7.8563 12.8018 7.37223 19H5C4.44772 19 4 19.4477 4 20C4 20.5523 4.44772 21 5 21H7.37223C7.8563 27.1982 12.8018 32.1437 19 32.6278V35C19 35.5523 19.4477 36 20 36C20.5523 36 21 35.5523 21 35V32.6278C27.1982 32.1437 32.1437 27.1982 32.6278 21H35C35.5523 21 36 20.5523 36 20C36 19.4477 35.5523 19 35 19H32.6278C32.1437 12.8018 27.1982 7.8563 21 7.37223V5ZM9.37959 19C9.85311 13.9071 13.9071 9.85311 19 9.37959V11.6667C19 12.219 19.4477 12.6667 20 12.6667C20.5523 12.6667 21 12.219 21 11.6667V9.37959C26.0929 9.85312 30.1469 13.9071 30.6204 19H28.3333C27.781 19 27.3333 19.4477 27.3333 20C27.3333 20.5523 27.781 21 28.3333 21H30.6204C30.1469 26.0929 26.0929 30.1469 21 30.6204V28.3333C21 27.781 20.5523 27.3333 20 27.3333C19.4477 27.3333 19 27.781 19 28.3333V30.6204C13.9071 30.1469 9.85312 26.0929 9.37959 21H11.6667C12.219 21 12.6667 20.5523 12.6667 20C12.6667 19.4477 12.219 19 11.6667 19H9.37959Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Localization;
